import React from "react";
import {connect} from "react-redux";
import {authActions, Loader, utils} from "@mc/mc-legacy";
import {withRouter} from "react-router";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import Type from "../api/gen/qsign/types/Type";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import QueryString from 'query-string';
import * as actions from "../actions/prePozadavkyNevyrizeneActions";

/**
 * Založení requestu na podpis z předběžného požadavku.
 */
class ZalozitPozadavekPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {preRequest: null, returnUrl: null, showModal: false};
    }

    static getUuidFromProps(props): string {
        try {
            return props.match.params.uuid
        } catch (e) {
            return null;
        }
    }

    static getReturnUrlFromLocation(location): string {
        const searchParams = QueryString.parse(location.search);
        return searchParams.returnUrl;
    }

    componentDidMount() {
       this.fetchData(this.props, true);
    }

    fetchData = (props, forceFetch) => {
        const uuid = ZalozitPozadavekPage.getUuidFromProps(props);
        const returnUrl = ZalozitPozadavekPage.getReturnUrlFromLocation(props.location);
        SignRequestInternalApi.getPreRequestByUuid(uuid).then((res) => this.setState({preRequest: res, returnUrl: returnUrl}));
    };

    handleZobrazit = (preRequest, returnUrl) => {
        const {dispatch, history} = this.props;
        dispatch(
            pdfViewerActions.showDocuments(
                preRequest,
                false,
                Type.ALL,
                () => {
                    if (returnUrl) {
                        window.location.href = returnUrl;
                    } else {
                        history.push("/ukoly/historie");
                    }
                },
                PodepisovaniPdfViewer.VIEW_MODE.BASE,
                screen.width,
                true,
                false
            )
        );
    };

    handleCloseAction = () => {
        const {history} = this.props;
        history.push("/pre/pozadavky/nevyrizene");
    }

    render() {
        const {dispatch, history, match: {params: {uuid}}} = this.props;
        const {preRequest, showModal} = this.state;

        if (preRequest) {
            if (!showModal) {
                dispatch(actions.createRequestByPre(preRequest, history, this.handleCloseAction));
                this.setState({showModal: true});
            }
            console.log('Nový požadavek na podpis dokumentů z předběžného požadavku: ' + uuid);
            return null;
        } else {
            return <Loader/>;
        }
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    };
}

export default withRouter(connect(mapStateToProps)(ZalozitPozadavekPage));
